<template>
  <v-container fluid>
    <v-row>
      <v-col class="pt-5">
        <h3>Aluminum Dies</h3>
      </v-col>
      <v-col class="text-end">
        <v-btn
          color="primary"
          outlined
          @click="openAluminumDieForm"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Aluminum Die
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="aluminumDies"
            :footer-props="footerProps"
            :items-per-page="20"
            :search="search"
            :loading="loading"
            dense
          >
            <template #[`item.code`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.code }}
              </text-highlight>
            </template>
            <template #[`item.type`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.type ? item.type.name : '' }}
              </text-highlight>
            </template>
            <template #[`item.description`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.description }}
              </text-highlight>
            </template>
            <template #[`item.weight_ratio`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.weight_ratio }}
              </text-highlight>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="openEditAluminumDieForm(item.id)"
              >
                EDIT
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="deleteAluminumDie(item.id)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <aluminum-die-form
      ref="aluminumDieForm"
      @success="getAluminumDies"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AluminumDieForm from '@/components/forms/AluminumDieForm.vue';

export default {
  components: {
    AluminumDieForm
  },
  props: {

  },
  data: () => ({
    aluminumDies: [],
    loading: false,
    headers: [
      { text: 'Code', value: 'code', sortable: false },
      { text: 'Type', value: 'type', sortable: false },
      { text: 'Description', value: 'description', sortable: false },
      { text: 'Weight Ratio', value: 'weight_ratio', sortable: false },
      {
        text: 'Actions', value: 'actions', width: '15%', align: 'end', sortable: false,
      },
    ],
    footerProps: {
      'items-per-page-options': [20, 50, 100, -1],
    },
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getAluminumDies();
    },

    async getAluminumDies() {
      this.aluminumDies = await this.$api.aluminumDie.get();
    },

    openAluminumDieForm() {
      this.$refs.aluminumDieForm.open();
    },

    openEditAluminumDieForm(id) {
      this.$refs.aluminumDieForm.open(id);
    },

    async deleteAluminumDie(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      const res = await this.$api.aluminumDie.delete(id);
      if (!res) return;
      this.$bus.$emit('showSuccess');
      this.getAluminumDies();
    },
  },
};
</script>

<style scoped>

</style>
